export const ResourceTypes = {
  PaymentInstrument: 'PaymentInstrument',
};

export const PidlErrorKeyI18nMap = {
  PIDLError_authTimeout_react: _TL_(
    'We have encountered an internal error. Please contact Support for further assistance.',
    {
      comment: 'Error from PIDL - We have encountered auth timeout.',
    }
  ),
  PIDLError_AuthenticationFailure_react: _TL_(
    'We have encountered an internal error. Please contact Support for further assistance.',
    {
      comment: 'Error from PIDL - We have encountered auth failure.',
    }
  ),
  PIDLError_BannedPaymentInstrument_react: _TL_(
    'We cannot accept your payment method. Please contact Support for further assistance.',
    {
      comment: 'Error from PIDL - The payment instrument cannot be used for transaction.',
    }
  ),
  PIDLError_InsufficientFund_react: _TL_(
    'Please use another way to pay. This payment method has insufficient funds.',
    {
      comment: 'Error from PIDL - The customer does not have enough funds in his/her payment instrument.',
    }
  ),
  PIDLError_InvalidCreditCardType_react: _TL_(
    "We're sorry, but we do not accept this card type. Please use another way to pay.",
    {
      comment: 'Error from PIDL - The payment instrument cannot be used for transaction.',
    }
  ),
  PIDLError_InvalidPaymentInstrumentType_react: _TL_(
    "We're sorry, but we do not accept this payment method in your country/region. Please use another way to pay.",
    {
      comment: 'Error from PIDL - The payment instrument is not valid for given country.',
    }
  ),
  PIDLError_InvalidPaymentMethodFamilyOrType_react: _TL_(
    'We cannot process your payment method. Please contact Support for further assistance.',
    {
      comment: 'Error from PIDL - Payment family or type parameter is missing or invalid.',
    }
  ),
  PIDLError_InvalidRequestData_react: _TL_(
    'We cannot process your payment method. Please contact Support for further assistance.',
    {
      comment: 'Error from PIDL - The request has invalid parameters. (For ex. Country is not passed in or payment instrument ID is not valid format or an unknown payment method type is passed)',
    }
  ),
  PIDLError_PaymentInstrumentAddAlready_react: _TL_(
    "You're all set! This payment method is already available.",
    {
      comment: 'Error from PIDL - The provided payment instrument already exists.',
    }
  ),
  PIDLError_PaymentInstrumentAlreadyActive_react: _TL_(
    "You're all set! This payment method is already available.",
    {
      comment: 'Error from PIDL - The payment instrument is in active state already.',
    }
  ),
  PIDLError_PaymentInstrumentAlreadyAdded_react: _TL_(
    "You're all set! This payment method is already available.",
    {
      comment: 'Error from PIDL - The provided payment instrument already exists.',
    }
  ),
  PIDLError_PaymentMethodTypeOrFamilyNotSupported_react: _TL_(
    "We're sorry, but we do not accept this payment method in your country/region. Please use another way to pay.",
    {
      comment: 'Error from PIDL - The specified type is not supported in the specified country.',
    }
  ),
  PIDLError_ProcessorTimeout_react: _TL_(
    'We cannot process your payment method. Please contact Support for further assistance.',
    {
      comment: 'Error from PIDL - The payment processor timed out during auth call.',
    }
  ),
  PIDLError_ProcessorUnreachable_react: _TL_(
    'We cannot process your payment method. Please use a different payment method, or contact your financial institution for further assistance.',
    {
      comment: 'Error from PIDL - An unknown error is returned from payment processor.',
    }
  ),
  PIDLError_ValidationFailed_react: _TL_(
    'We could not process your payment method. Please verify that your card information is correct, and try again. If you continue to have issues, please use a different payment method, or contact your financial institution.',
    {
      comment: 'Error from PIDL - The payment instrument cannot be validated. Payment processor decline.',
    }
  ),
  PIDLError_PrepaidCardNotSupported_react: _TL_(
    'Prepaid cards can only be used for certain currency and country/region combinations. See {{0}}Choosing a payment method{{1}} for more info.',
    {
      comment: 'Error from PIDL - The payment instrument provided was a Prepaid card. This is not supported. {{0}} {{1}} is the html tag for the link to open How do I pay for Microsoft Advertising? in the  help menu.',
    }
  ),
  PIDLError_ExceedRetryMaximum_react: _TL_(
    'We can’t validate this SEPA direct debit - too many incorrect verification values attempted. Please add the payment method again and restart the validation.',
    {
      comment: 'Error from PIDL - The user has tried to valida his SEPA payment method to many times.',
    }
  ),
  PIDLError_InsufficientPermission_react: _TL_(
    "You don't have sufficient permission to use this payment method. Please use another way to pay.",
    {
      comment: 'Error from PIDL - The user has insufficient permission for current payment method.',
    }
  ),
  PIDLError_TokenizationFailed_react: _TL_(
    'We cannot tokenize this payment method. Please contact Support for further assistance.',
    {
      comment: 'Error from PIDL - Failed to tokenize current payment method.',
    }
  ),
  PIDLError_undefined_react: _TL_(
    'We have encountered an internal error. Please contact Support for further assistance.',
    {
      comment: 'Error from PIDL - We have encountered an internal error.',
    }
  ),
  PIDLError_RejectedByProvider_react: _TL_(
    'We have encountered an internal error. Please contact Support for further assistance.',
    {
      comment: 'Error from PIDL - We have encountered an internal error.',
    }
  ),
  PIDLError_InternalError_react: _TL_(
    'We have encountered an internal error. Please contact Support for further assistance.',
    {
      comment: 'Error from PIDL - We have encountered an internal error.',
    }
  ),
  PIDLError_InvalidStateTransitionRequested_react: _TL_(
    'We have encountered an internal error. Please contact Support for further assistance.',
    {
      comment: 'Error from PIDL - We have encountered an internal error.',
    }
  ),
  PIDLError_AuthenticationTokenInvalid_react: _TL_(
    'We have encountered an internal error. Please contact Support for further assistance.',
    {
      comment: 'Error from PIDL - We have encountered an internal error.',
    }
  ),
  PIDLError_InstrumentStoreServiceCallFailed_react: _TL_(
    'We have encountered an internal error. Please contact Support for further assistance.',
    {
      comment: 'Error from PIDL - We have encountered an internal error.',
    }
  ),
};
